import { Suspense, useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Footer } from "./components/Footer";
import { Navbar } from "./components/Navbar";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Home } from "./pages/Home";
import { Projects } from "./pages/Projects";
import { Skills } from "./pages/Skills";
import { FirstLoader } from "./components/FirstLoader";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./theme/theme";
import { GlobalStyles } from "./styled-components/GlobalStyles";
import { ToastContainer } from 'react-toastify';

function App() {
	const [theme, setTheme] = useState('light');

	const toggleTheme = () => {
		setTheme(theme === 'light' ? 'dark' : 'light');
	};

	useEffect(() => {
		Aos.init({ duration: 2000 });
	}, []);

	return (
		<>
			<Suspense
				fallback={
					<div className="loader__className">
						<FirstLoader />
					</div>
				}
			>
				<ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
					<ToastContainer />
					<Navbar theme={theme} toggleTheme={toggleTheme} />
					<Home />
					<About />
					<Skills />
					<Projects />
					<Contact />
					<Footer />
					<GlobalStyles />
				</ThemeProvider>
				{/* <Navbar />
				<Home />
					<About />
					<Skills />
					<Projects />
					<Contact />
					<Footer /> */}
			</Suspense>
		</>
	);
}

export default App;
